import { TLoginApiResponse, TLoginUser } from '@/types/users';
import ApiService from './ApiService';

class LoginRepository extends ApiService {
  constructor() {
    super('/admin/auth');
  }

  async login(loginData: TLoginUser): Promise<TLoginApiResponse> {
    return await this.post<TLoginApiResponse>('/login', loginData);
  }

  async refresh(refreshToken: string): Promise<TLoginApiResponse> {
    return await this.post<TLoginApiResponse>('/refresh', { refreshToken });
  }

  async logout() {
    return await this.delete('/session');
  }
}

export default new LoginRepository();
